const APP_STORE_URL = "https://apps.apple.com/fr/app/echo-glow-up-mentalement/id6751498310";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.company.echo&hl=fr";

export default function StoreBadges({ className = "", testidPrefix = "store" }) {
  return (
    <div className={`flex flex-wrap items-center justify-center gap-3 sm:gap-4 ${className}`}>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${testidPrefix}-app-store-button`}
        className="group inline-flex items-center gap-3 px-5 py-3 rounded-2xl bg-white/[0.06] border border-white/15 text-white hover:bg-white/[0.09] hover:border-white/25 transition-all duration-300 hover:scale-[1.03] backdrop-blur-md"
        aria-label="Télécharger sur l'App Store"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M17.564 12.639c-.025-2.527 2.063-3.746 2.157-3.807-1.177-1.717-3.006-1.952-3.657-1.978-1.556-.157-3.036.919-3.826.919-.79 0-2.007-.895-3.301-.87-1.699.025-3.267.988-4.14 2.51-1.767 3.056-.451 7.578 1.264 10.06.84 1.216 1.841 2.581 3.15 2.532 1.264-.051 1.741-.819 3.267-.819s1.955.819 3.301.794c1.365-.025 2.229-1.24 3.062-2.463.966-1.415 1.363-2.79 1.388-2.859-.031-.013-2.663-1.022-2.689-4.056zM15.11 4.877c.698-.847 1.169-2.022.965-3.19-1.007.041-2.226.671-2.948 1.517-.647.749-1.213 1.945-1.059 3.09 1.124.087 2.271-.571 3.042-1.418z"/>
        </svg>
        <div className="flex flex-col leading-none text-left">
          <span className="text-[10px] font-medium opacity-70">Télécharger sur</span>
          <span className="text-base font-bold tracking-tight">App Store</span>
        </div>
      </a>

      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${testidPrefix}-play-store-button`}
        className="group inline-flex items-center gap-3 px-5 py-3 rounded-2xl bg-white/[0.06] border border-white/15 text-white hover:bg-white/[0.09] hover:border-white/25 transition-all duration-300 hover:scale-[1.03] backdrop-blur-md"
        aria-label="Disponible sur Google Play"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M3.6 2.3c-.3.3-.4.7-.4 1.3v16.8c0 .6.2 1 .5 1.3l.1.1L13.2 12v-.2L3.7 2.3l-.1.1z" fill="url(#g1)"/>
          <path d="M16.5 15.2 13.2 12v-.2l3.3-3.3.1.1L20.5 11c1.1.6 1.1 1.7 0 2.3l-4 2.1c.1-.1.1-.1 0-.2z" fill="url(#g2)"/>
          <path d="M16.6 15.1 13.2 11.8 3.6 21.4c.4.4 1 .4 1.7.1l11.3-6.4" fill="url(#g3)"/>
          <path d="M16.6 8.6 5.3 2.2c-.7-.4-1.3-.3-1.7.1l9.6 9.5 3.4-3.2z" fill="url(#g4)"/>
          <defs>
            <linearGradient id="g1" x1="12.3" y1="3.4" x2="1.4" y2="14.4" gradientUnits="userSpaceOnUse">
              <stop stopColor="#00A0FF"/><stop offset="0.7" stopColor="#00A1FF"/><stop offset="1" stopColor="#00AEFF"/>
            </linearGradient>
            <linearGradient id="g2" x1="21.8" y1="12" x2="2.8" y2="12" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FFE000"/><stop offset="0.4" stopColor="#FFBD00"/><stop offset="0.8" stopColor="#FFA500"/><stop offset="1" stopColor="#FF9C00"/>
            </linearGradient>
            <linearGradient id="g3" x1="14.7" y1="13.8" x2="-0.5" y2="29.1" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FF3A44"/><stop offset="1" stopColor="#C31162"/>
            </linearGradient>
            <linearGradient id="g4" x1="1.1" y1="-0.9" x2="7.9" y2="5.9" gradientUnits="userSpaceOnUse">
              <stop stopColor="#32A071"/><stop offset="0.1" stopColor="#2DA771"/><stop offset="0.5" stopColor="#15CF74"/><stop offset="0.8" stopColor="#06E775"/><stop offset="1" stopColor="#00F076"/>
            </linearGradient>
          </defs>
        </svg>
        <div className="flex flex-col leading-none text-left">
          <span className="text-[10px] font-medium opacity-70">Disponible sur</span>
          <span className="text-base font-bold tracking-tight">Google Play</span>
        </div>
      </a>
    </div>
  );
}
